import Icon, { IconList } from 'components/Icon'
import './LocationListHeader.css';
import PropTypes from 'prop-types';
import SearchBox from 'components/SearchBox';

const LocationListHeader = ({ keyword, onSearch }) => {
    return (
        <div className='location-list-header-flex-row location-list_header'>
                <div className='location-list-header-flex-row location-header-title'>
                    <Icon icon={IconList.iconListing} />
                    <label className='header-text'>設置箇所一覧</label>
                </div>
                <div className='location-list-header-flex-row location-header-top-container'>
                    <div className='location_page_search_box_container'>
                    <SearchBox 
                        defaultKeyword={keyword}
                        onSearch={onSearch}
                    />
                    </div>
                </div>
            
        </div>
    )
}

LocationListHeader.propTypes = {
    keyword: PropTypes.string,
    onSearch: PropTypes.func,
}

LocationListHeader.defaultProps = {
    keyword: '',
    onSearch: () => {},
}

export default LocationListHeader;